/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventNum: NonNullable<unknown> }} Error_Nav_Event_Selected_ToastInputs */



/**
* | output |
* | --- |
* | "Event {eventNum} selected." |
*
* @param {Error_Nav_Event_Selected_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_event_selected_toast = /** @type {((inputs: Error_Nav_Event_Selected_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Event_Selected_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Evenement ${i?.eventNum} selectionne.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ereignis ${i?.eventNum} ausgewählt.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Evento ${i?.eventNum} selezionato.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Выбрано событие ${i?.eventNum}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Evento ${i?.eventNum} seleccionado.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已选择事件${i?.eventNum}。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント${i?.eventNum}が選択されました。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इवेंट ${i?.eventNum} का चयन किया गया।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Evento ${i?.eventNum} selecionado.`)
	return /** @type {LocalizedString} */ (`Event ${i?.eventNum} selected.`)
});